import { render, staticRenderFns } from "./curriculumPublic.vue?vue&type=template&id=05c35fbe&scoped=true&"
import script from "./curriculumPublic.vue?vue&type=script&lang=js&"
export * from "./curriculumPublic.vue?vue&type=script&lang=js&"
import style0 from "./curriculumPublic.vue?vue&type=style&index=0&id=05c35fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c35fbe",
  null
  
)

export default component.exports